import React, { useEffect, useState } from 'react';
import { Card, Grid, Paper } from '@mui/material';
import { AppContext } from '../../context/AppContext';
import BakeasyEmptyMsg from '../../components/common/BakeasyEmptyMsg';
import BakeasyHeaderLabel from '../../components/labels/BakeasyHeaderLabel';
import BakeasySimpleTable from '../../components/tables/BakeasySimpleTable';
import { t } from 'i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { BakeasyAppBar } from '../../components/common/BakeasyAppBar';
import BakeasyLargeHeadingValue, {
  BakeasyLargeHeadingStatus,
} from '../../components/labels/BakeasyLargeHeadingValue';
import { BakeasyNotesLabelText } from '../../components/labels/BakeasyLabelText';
import BakeasyDivider from '../../components/common/BakeasyDivider';
import { useAppDispatch, useAppSelector } from '../../redux_store/reduxStore';
import {
  downloadShippingDetails,
  fetchShippingById,
  shippingsState,
} from '../../redux_store/slices/shippingsSlice';
import { showErrorSnackbar } from '../../redux_store/slices/snackbarSlice';
import BakeasyLinkButton from '../../components/buttons/BakeasyLinkButton';
import i18n from '../../languages/languages';
import BakeasyTextField from '../../components/textfields/BakeasyTextField';
import BakeasyDatePicker from '../../components/common/BakeasyDatePicker';
import dayjs from 'dayjs';
import * as Dropdown from '../../components/dropdowns/BakeasySelect';
import { BakeasyChip } from '../../components/common/BakeasyChip';
import { HeadCell } from '../../components/tables/BakeasyTable';
import * as Button from '../../components/buttons/BakeasyButtons';

export const ShippingDetails = (props: any) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  let myContext = React.useContext(AppContext);

  const [storeNotes, setStoreNotes] = useState<string>('');
  const [shippingId, setShippingId] = useState<string>('');
  const [orderId, setOrderId] = useState<string>('');
  const [orderBy, setOrderBy] = useState<any>();
  const [orderStatus, setOrderStatus] = useState<string>('');
  const [requestedDeliveryDate, setRequestedDeliveryDate] = useState<any>('');
  const [highPriority, setHighPriority] = useState<any>('');
  const [shippingDate, setShippingDate] = useState<string>('');
  const [invoiceDate, setInvoiceDate] = useState<string>('');
  const [orderDate, setOrderDate] = useState<string>('');

  const [storeId, setStoreId] = useState<string>('');
  const [storeName, setStoreName] = useState<string>('');
  const [storeEmailId, setStoreEmailId] = useState<string>('');
  const [storePo, setStorePo] = useState<string>('');
  const [latestStoreNote, setLatestStoreNote] = useState<any>(undefined);

  const [supplierName, setSupplierName] = useState<string>('');
  const [latestSupplierNote, setLatestSupplierNote] = useState<any>(undefined);

  const [shipTo, setShipTo] = useState<string>('');
  const [shippingName, setShippingName] = useState<string>('');
  const [shippingCompanyName, setShippingCompanyName] = useState<string>('');
  const [shippingCompanyAddress, setShippingCompanyAddress] =
    useState<string>('');
  const [shippingCity, setShippingCity] = useState<string>('');
  const [shippingState, setShippingState] = useState<string>('');
  const [shippingPostCode, setShippingPostCode] = useState<string>('');
  const [shippingCountry, setShippingCountry] = useState<string>('');
  const [preferredShippingMethod, setPreferredShippingMethod] =
    useState<string>('');
  const [shippingRate, setShippingRate] = useState<any>('');
  const [shippingCalculation, setShippingCalculation] = useState<any>('');
  const [shippingCharges, setShippingCharges] = useState<any>('');

  const [taxNumber1, setTaxNumber1] = useState<any>('');
  const [taxNumber2, setTaxNumber2] = useState<any>('');
  const [selectedTaxRate1, setSelectedTaxRate1] = useState<any>('');
  const [selectedTaxRate2, setSelectedTaxRate2] = useState<any>('');
  const [paymentTerms, setPaymentTerms] = useState<string>('');
  const [paymentMethod, setPaymentMethod] = useState<string>('');

  const [products, setProducts] = useState<any[]>([]);
  const [total, setTotal] = useState<any>([{}]);
  const [status, setStatus] = useState<string>('');

  let { loading, error, value, pageNo, filter, selectedValue } =
    useAppSelector(shippingsState);

  useEffect(() => {
    fetchData(location?.state?.id);
  }, []);

  const fetchData = async (_id: any) => {
    try {
      await dispatch(fetchShippingById({ id: _id }));
    } catch (error) {
      dispatch(showErrorSnackbar({ message: error }));
    }
  };

  useEffect(() => {
    if (selectedValue) {
      setData(selectedValue);
    }
  }, [selectedValue]);

  function setData(data: any) {
    setStatus(data?.status);
    setShippingName(data?.shippingName);
    setShippingId(data?.shippingId);
    setOrderId(data?.orderId);
    setHighPriority(data?.priority ? 'Yes' : 'No');
    setOrderBy(data?.orderBy);
    setRequestedDeliveryDate(data?.requestedDeliveryDate);
    setShippingDate(data?.shippingDate);
    setInvoiceDate(data?.invoiceDate);
    setOrderDate(data?.orderDate);
    setOrderStatus(data?.status);

    setStoreId(data?.storeDetails?.storeNumber);
    setStoreName(data?.storeDetails?.storeName);
    setStoreEmailId(data?.storeDetails?.contact1?.email);
    setStorePo(data?.poNumber);
    setLatestStoreNote(
      data?.storeNotes
        ? data?.storeNotes?.at(data?.storeNotes?.length - 1)?.notes?.toString()
        : t('NO_STORE_NOTES_AVAILABLE')
    );
    setStoreNotes(data?.storeNotes);

    setSupplierName(data?.supplierName);
    setLatestSupplierNote(
      data?.supplierNotes
        ?.at(data?.supplierNotes?.length - 1)
        ?.notes?.toString()
    );

    setShipTo(data?.shipTo);
    setShippingName(data?.shipToInfo?.name);
    setShippingCompanyName(data?.shipToInfo?.companyName);
    setShippingCompanyAddress(data?.shipToInfo?.companyAddress);
    setShippingCity(data?.shipToInfo?.city);
    setShippingState(data?.shipToInfo?.state);
    setShippingPostCode(data?.shipToInfo?.zipCode);
    setShippingCountry(data?.shipToInfo?.country);
    setShippingCharges(
      data?.shippingCharges
        ? i18n.language === 'fr'
          ? 'Oui'
          : 'Yes'
        : i18n.language === 'fr'
          ? 'Non'
          : 'No'
    );
    setShippingCalculation(data?.shippingRateType);
    setShippingRate(data?.shippingRate);
    setPreferredShippingMethod(data?.preferredShippingMethod);

    setPaymentTerms(data?.storeDetails?.payment?.terms?.[i18n.language]);
    setPaymentMethod(data?.storeDetails?.payment?.method?.[i18n.language]);
    // setPaymentTerms(data?.payment?.terms);
    // setPaymentMethod(data?.payment?.method);
    // setTaxNumber1(data?.taxes?.tax1);
    // setTaxNumber2(data?.taxes?.tax2);
    setSelectedTaxRate1(data?.taxes?.rate1);
    setSelectedTaxRate2(data?.taxes?.rate2);

    const productDetails = data?.shippedProducts?.map((item: any) => {
      return {
        productName: item?.productName,
        productId: item?.userProductId,
        description: item?.description,
        quantity: item?.quantity,
        shippingQuantity: item?.shippingQuantity,
        unitPrice: item?.price,
        totalPrice: (Number(item?.quantity) * Number(item?.price)).toFixed(2),
        // backOrder: item?.productName
      };
    });

    setTotal({
      ...data?.amount,
      // calculatedshippingCharge:
      //   selectedValue !== null && 'shippingRateType' in selectedValue
      //     ? selectedValue['shippingRateType'] === 'Amount'
      //       ? t('TO_BE_CONFIRMED')
      //       : data?.amount?.calculatedshippingCharge
      //     : '',
    });

    setProducts([...productDetails]);
  }

  function openSupplierNotesDialog(
    isEdit: any,
    from: string,
    fetchMethod: any
  ) {
    return myContext.setDialog({
      open: true,
      dialogContent: {
        pageName: 'supplierNotesHistory',
        params: { isEdit, from, fetchMethod },
        onBack: async () => {},
      },
    });
  }

  function openStoreNotesDialog(isEdit: any, from: string) {
    return myContext.setDialog({
      open: true,
      dialogContent: {
        pageName: 'storeNotesHistory',
        params: { isEdit, from },
        onBack: async () => {},
      },
    });
  }

  const tableHeaders: HeadCell[] = [
    { id: 'productName', label: 'PRODUCT_NAME', width: '200px' },
    { id: 'productId', label: 'PRODUCT_ID', width: '160px' },
    { id: 'unitPrice', label: 'UNIT_PRICE', numeric: true, width: '120px' },
    {
      id: 'quantity',
      numeric: true,
      label: 'QUANTITY_ORDERED',
      width: '120px',
      disabled: true,
    },
    {
      id: 'shippingQuantity',
      numeric: true,
      label: 'QUANTITY_SHIPPED',
      width: '120px',
    },
    { id: 'totalPrice', label: 'TOTAL_PRICE', numeric: true, width: '120px' },
    //{ id: 'backorder', numeric: true, disablePadding: false, label: 'BACK_ORDER' }
  ];

  function deliveryDetailsUI() {
    return (
      <Grid>
        <Grid item>
          <BakeasyAppBar
            title={t('SHIPPING_DETAILS')}
            menus={
              <Button.Print
                onClick={function (
                  event: React.MouseEvent<HTMLButtonElement, MouseEvent>
                ): void {
                  dispatch(
                    downloadShippingDetails({
                      id: location?.state?.id,
                      downloadType: 'pdf',
                    })
                  );
                }}
              />
            }
            onBackClick={() => {
              navigate(-1);
            }}
          />
        </Grid>
        <Paper component={Card} variant="outlined" sx={{ p: 2, mt: 1 }}>
          <Grid container>
            <Grid item xs={12} sm={12}>
              <BakeasyLargeHeadingValue
                heading={t('ORDER_ID')}
                value={orderId}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <BakeasyLargeHeadingValue
                heading={t('SHIPPING_ID')}
                value={shippingId}
              />
            </Grid>
          </Grid>

          <Grid item xs={12} sm={12}>
            <BakeasyLargeHeadingStatus
              heading={t('ORDER_STATUS')}
              value={<BakeasyChip label={status} />}
            />
          </Grid>

          <Grid container mt={1}>
            <Grid item container>
              <BakeasyHeaderLabel message="ORDER_DETAILS" />
            </Grid>
            <Grid item container spacing={2} pl={2}>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyTextField
                  required={true}
                  label={t('ORDER_BY')}
                  disabled={true}
                  type="text"
                  name=""
                  value={orderBy}
                  maxLength={10}
                  onChange={function (event: any): void {
                    setOrderBy(event?.target?.value);
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyTextField
                  required={true}
                  label={t('ORDER_STATUS')}
                  disabled={true}
                  type="text"
                  name=""
                  value={orderStatus}
                  maxLength={10}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyDatePicker
                  label={t('REQUESTED_DELIVERY_DATE')}
                  disabled={true}
                  value={dayjs(requestedDeliveryDate)}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <Dropdown.YesNo
                  label={'HIGH_PRIORITY'}
                  disabled={true}
                  value={highPriority}
                  onChange={(event: any) => {
                    setHighPriority(event?.target?.value);
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyDatePicker
                  label={t('SHIPPING_DATE')}
                  disabled={true}
                  value={dayjs(shippingDate)}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyDatePicker
                  label={t('INVOICE_DATE')}
                  disabled={true}
                  value={dayjs(invoiceDate)}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyDatePicker
                  label={t('ORDER_DATE')}
                  disabled={true}
                  value={dayjs(orderDate)}
                />
              </Grid>
            </Grid>
          </Grid>
          <BakeasyDivider />

          <Grid container>
            <Grid item container sx={{ marginTop: 0 }}>
              <BakeasyHeaderLabel message={t('STORE_DETAILS')} />
            </Grid>
            <Grid item container spacing={2} pl={2}>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyTextField
                  required={true}
                  label={t('STORE_ID')}
                  disabled={true}
                  type="text"
                  name=""
                  value={storeId}
                  maxLength={10}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyTextField
                  required={true}
                  label={t('NAME')}
                  disabled={true}
                  type="text"
                  name=""
                  value={storeName}
                  maxLength={10}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyTextField
                  required={true}
                  label={t('EMAIL_ID')}
                  disabled={true}
                  type="text"
                  name=""
                  value={storeEmailId}
                  maxLength={10}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyTextField
                  required={true}
                  label={t('STORE_PO')}
                  disabled={true}
                  type="text"
                  name=""
                  value={storePo}
                  maxLength={30}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3} marginTop={1}>
                <BakeasyNotesLabelText
                  label={t('STORE_NOTES')}
                  value={latestStoreNote}
                  maxLength={800}
                />
                <BakeasyLinkButton
                  style={{ fontSize: '0.9rem' }}
                  label={t('VIEW_ALL')}
                  onClick={() => {
                    if (latestStoreNote === undefined) {
                      dispatch(
                        showErrorSnackbar({
                          message: t('NO_STORE_NOTES_AVAILABLE'),
                        })
                      );
                      return;
                    }
                    openStoreNotesDialog(false, 'shippingDetails');
                  }}
                />
              </Grid>
            </Grid>
          </Grid>

          <BakeasyDivider />

          <Grid container>
            <Grid item container>
              <BakeasyHeaderLabel message={t('SUPPLIER_DETAILS')} />
            </Grid>
            <Grid item container spacing={2} pl={2}>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyTextField
                  required={true}
                  label={t('SUPPLIER_NAME')}
                  disabled={true}
                  type="text"
                  name=""
                  value={supplierName}
                  maxLength={10}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3} marginTop={1}>
                <BakeasyNotesLabelText
                  label={t('SUPPLIER_NOTES')}
                  value={latestSupplierNote}
                  maxLength={800}
                />
                <BakeasyLinkButton
                  style={{ fontSize: '0.9rem' }}
                  label={t('VIEW_ALL')}
                  onClick={() => {
                    openSupplierNotesDialog(
                      false,
                      'shippingDetails',
                      fetchShippingById
                    );
                  }}
                />
              </Grid>
            </Grid>
          </Grid>

          <BakeasyDivider />

          <Grid container>
            <Grid item container>
              <BakeasyHeaderLabel message={t('SHIPPING_DETAILS')} />
            </Grid>
            <Grid item container spacing={2} pl={2}>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyTextField
                  required={true}
                  label={t('SHIP_TO')}
                  disabled={true}
                  type="text"
                  name=""
                  // value={shipTo}
                  value={
                    shipTo
                      ? t(`${shipTo?.toUpperCase().replace(/\s+/g, '_')}`)
                      : shipTo
                  }
                  maxLength={10}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyTextField
                  required={true}
                  label={t('NAME')}
                  disabled={true}
                  type="text"
                  name=""
                  value={shippingName}
                  maxLength={10}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyTextField
                  required={true}
                  label={t('COMPANY_NAME')}
                  disabled={true}
                  type="text"
                  name=""
                  value={shippingCompanyName}
                  maxLength={10}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyTextField
                  required={true}
                  label={t('COUNTRY')}
                  disabled={true}
                  type="text"
                  name=""
                  // value={shippingCountry}
                  value={
                    shippingCountry
                      ? t(
                          `${shippingCountry?.toUpperCase().replace(/\s+/g, '_')}`
                        )
                      : shippingCountry
                  }
                  maxLength={10}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyTextField
                  required={true}
                  label={t('STATE')}
                  disabled={true}
                  type="text"
                  name=""
                  // value={shippingState}
                  value={
                    shippingState
                      ? t(
                          `${shippingState?.toUpperCase().replace(/\s+/g, '_')}`
                        )
                      : shippingState
                  }
                  maxLength={10}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyTextField
                  required={true}
                  label={t('CITY')}
                  disabled={true}
                  type="text"
                  name=""
                  value={shippingCity}
                  maxLength={10}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyTextField
                  required={true}
                  label={t('POSTAL_CODE')}
                  disabled={true}
                  type="text"
                  name=""
                  value={shippingPostCode}
                  maxLength={10}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyTextField
                  required={true}
                  label={t('COMPANY_ADDRESS')}
                  disabled={true}
                  type="text"
                  name=""
                  value={shippingCompanyAddress}
                  maxLength={10}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyTextField
                  required={true}
                  label={t('SHIPPING_CHARGE')}
                  disabled={true}
                  type="text"
                  name=""
                  value={shippingCharges}
                  maxLength={10}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyTextField
                  required={true}
                  label={t('SHIPPING_CALCULATION')}
                  disabled={true}
                  type="text"
                  name=""
                  value={shippingCalculation}
                  maxLength={10}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyTextField
                  required={true}
                  label={t('SHIPPING_CHARGES')}
                  disabled={true}
                  type="text"
                  name=""
                  value={shippingRate}
                  maxLength={10}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyTextField
                  required={true}
                  label={t('SHIPPING_METHOD')}
                  disabled={true}
                  type="text"
                  name=""
                  value={preferredShippingMethod}
                  maxLength={10}
                />
              </Grid>
            </Grid>
          </Grid>

          <BakeasyDivider />

          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <BakeasyHeaderLabel message={t('TAXES')} />
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid container spacing={2} pl={2}>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <BakeasyTextField
                      required={true}
                      label={t('STORE_TAX1')}
                      disabled={true}
                      type="text"
                      name=""
                      value={selectedTaxRate1}
                      maxLength={10}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <BakeasyTextField
                      required={true}
                      label={t('STORE_TAX2')}
                      disabled={true}
                      type="text"
                      name=""
                      value={selectedTaxRate2}
                      maxLength={10}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <BakeasyTextField
                      required={true}
                      label={t('STORE_TAX1_RATE')}
                      disabled={true}
                      type="text"
                      name=""
                      value={
                        selectedTaxRate1
                          ? selectedTaxRate1?.split(' - ', 10).pop()
                          : ''
                      }
                      maxLength={10}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <BakeasyTextField
                      required={true}
                      label={t('STORE_TAX2_RATE')}
                      disabled={true}
                      value={
                        selectedTaxRate2
                          ? selectedTaxRate2?.split(' - ', 10).pop()
                          : ''
                      }
                      maxLength={10}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <BakeasyHeaderLabel message={t('PAYMENT')} />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid container spacing={2} pl={2}>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <BakeasyTextField
                      required={true}
                      label={t('METHOD')}
                      disabled={true}
                      // value={paymentMethod}
                      value={
                        paymentMethod
                          ? t(
                              `${paymentMethod?.toUpperCase().replace(/\s+/g, '_')}`
                            )
                          : paymentMethod
                      }
                      maxLength={10}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <BakeasyTextField
                      required={true}
                      label={t('TERMS')}
                      disabled={true}
                      type="text"
                      name=""
                      // value={paymentTerms}
                      value={
                        paymentTerms
                          ? t(
                              `${paymentTerms?.toUpperCase().replace(/\s+/g, '_')}`
                            )
                          : paymentTerms
                      }
                      maxLength={10}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <BakeasyDivider />

          <Grid>
            {products?.length > 0 ? (
              <BakeasySimpleTable
                headers={tableHeaders}
                tableData={products}
                type={'shippingDetails'}
                data={total}
              />
            ) : (
              <BakeasyEmptyMsg message={t('NO_DATA_FOUND')} />
            )}
          </Grid>
        </Paper>
      </Grid>
    );
  }

  return deliveryDetailsUI();
};
